// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"dq-z","imageAndVideoCount":"eq-z","imageAndVideoContainer":"fq-z","viewAllReviews":"gq-z"};